import { useEffect, useState } from "react";
import "../../assets/css/storage/storage.css";
import { Badge, ButtonGroup } from "react-bootstrap";
import { provisionerTypeLogo } from "../../settings/shared/commonMethods";
import StorageConfigService from "../../services/api/storageConfig";

const StorageInfoList = (props) => {

    const [getStorageId, setStorageId] = useState("");
    const [getBucketName, setBucketName] = useState("");
    const [getConfigData, setConfigData] = useState([]);

    useEffect(() => {
        getAllStorageConfigList();
    }, [props.storageId]);

    const getAllStorageConfigList = () => {
        StorageConfigService.getAllStorageConfig()
            .then((response) => {
                if (response?.status === 'SUCCESS') {
                    let configData = [];
                    configData = response?.storageDTOPage?.content;
                    configArrayModified(configData);
                }
            }
            );
    }

    const configArrayModified = (data) => {
        let platformDefault = getPlatformDefaultConfig(data);
        if (platformDefault !== null && platformDefault !== undefined) {
            setStorageId(platformDefault.id);
            props._getStorageInfo(platformDefault, null);
        }

        const arrWithColor = (data || []).map(object => ({ ...object, expandFlag: false }));
        setConfigData(arrWithColor);
    }

    const getPlatformDefaultConfig = (data) => {
        let platformDefault = data.filter(item => item.platformDefault);
        if (platformDefault.length > 0) {
            return platformDefault[0];
        }
    }

    const clickExpandTrue = (index, flag) => {
        setConfigData(prevData => prevData.map((item, i) => i === index ? { ...item, expandFlag: flag } : item));
    }

    const onBucketNameCickEvent = (item, bucketData) => {
        setStorageId(item.id);
        setBucketName(bucketData !== null ? bucketData.bucketName : "");
        //TODO Call Storage file 
        props._getStorageInfo(item, bucketData.bucketName);
    }

    const onStorageNameCickEvent = (item) => {
        setStorageId(item.id);
        if (item.storageConfig === null) {
            setBucketName("");
            props._getStorageInfo(item, null);
        }
    }

    return (
        <div className="w-100">
            {getConfigData.length === 0 && (
                <ButtonGroup className="w-100 chatLoading verticalAligntxt justify-content-center mt-3">
                    <Badge bg="info">Loading…</Badge>
                </ButtonGroup>
            )}

            {getConfigData?.length > 0 && (
                <div className="sc-connections">
                    {getConfigData.map((item, index) => {
                        const buckets = item?.storageConfig?.bucketStorages || [];
                        const hasBuckets = buckets.length > 0;
                        return (
                            <div key={item.id || index} className="sc-conn-card">
                                <div
                                    className={`sc-conn-row ${getStorageId === item.id ? "is-active" : ""} ${item.storageStatus === "DISABLED" ? "is-disabled" : ""}`}
                                    onClick={() => onStorageNameCickEvent(item)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            onStorageNameCickEvent(item);
                                        }
                                    }}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <div className="sc-conn-row-inner">
                                        {hasBuckets ? (
                                            <button
                                                type="button"
                                                className="sc-conn-chevron"
                                                aria-expanded={!!item.expandFlag}
                                                aria-label={item.expandFlag ? "Collapse buckets" : "Expand buckets"}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    clickExpandTrue(index, !item.expandFlag);
                                                }}
                                            >
                                                <i className={`fas fa-chevron-${item.expandFlag ? "down" : "right"} font11`} />
                                            </button>
                                        ) : (
                                            <span className="sc-conn-chevron-placeholder" aria-hidden="true" />
                                        )}

                                        <div className="sc-conn-icon-wrap">
                                            <img
                                                src={provisionerTypeLogo(item.platformDefault ? undefined : item.provisionerType)}
                                                alt=""
                                                className="sc-conn-icon"
                                            />
                                        </div>

                                        <div className="sc-conn-body">
                                            <div className="sc-conn-title-line">
                                                <span className="sc-conn-name text-truncate" title={item.name}>
                                                    {item.platformDefault ? "Default Storage" : item.name}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {item.expandFlag && hasBuckets && (
                                    <div className="sc-conn-buckets">
                                        {buckets.map((bucketItem, bucketIndex) => (
                                            <button
                                                key={bucketIndex}
                                                type="button"
                                                className={`sc-conn-bucket-pill ${getBucketName === bucketItem.bucketName ? "is-active" : ""}`}
                                                onClick={() => onBucketNameCickEvent(item, bucketItem)}
                                            >
                                                <i className="fa-brands fa-bitbucket" aria-hidden="true" />
                                                <span className="text-truncate">{bucketItem.bucketName}</span>
                                                {bucketItem.primary && (
                                                    <i className="fas fa-star sc-conn-bucket-star" title="Primary bucket" />
                                                )}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    )

}

export default StorageInfoList;